import script from "./ComLisaaNimike.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComLisaaNimike.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__